import type { Member, Tenant, Workspace } from "@/domain/types";
import { authApi, db } from "@/infra/cloud-adapter/client";

export async function listTenants(): Promise<Tenant[]> {
  const { data, error } = await db().from("tenants").select("id,name,slug,deployment_mode").order("name");
  if (error) throw error;
  return (data ?? []) as Tenant[];
}
export async function listWorkspaces(tenantId: string): Promise<Workspace[]> {
  const { data, error } = await db().from("workspaces").select("id,tenant_id,name,description,logo_url,website_url").eq("tenant_id", tenantId).order("name");
  if (error) throw error;
  return (data ?? []) as Workspace[];
}
export async function listMembers(tenantId: string): Promise<Member[]> {
  const { data, error } = await db().from("tenant_memberships").select("user_id,email,role").eq("tenant_id", tenantId).order("email");
  if (error) throw error;
  return (data ?? []) as Member[];
}
export const signInConfig = () => authApi.config();
